import { Fase } from '../interfaces/treatment';

export class MFase{
    public id: number = null;
    public name: string = null;
    public order: number = null;

    constructor(fase: Fase){
        this.id = fase.id;
        this.name = fase.nombre;
        this.order = parseInt(fase.orden)
    }
}